import { createRoot } from "react-dom/client";
import AllTen from "./all-ten";
import "./all-ten.css";

const root = document.getElementById("all-ten-root");

if (root) {
  createRoot(root).render(<AllTen />);
}

export default AllTen;
